module.exports = __webpack_public_path__ + "img/product-showcase.ce4c3773.jpg";